module.exports = __webpack_public_path__ + "img/img5.fca06661.png";